import { Pipe, PipeTransform } from '@angular/core';
import * as _ from 'lodash';

@Pipe({
    name: 'groupBy',
    standalone: false
})
export class GroupByPipe implements PipeTransform {
  transform(value: Array<any>, field: string): Array<any> {
    const groupedObj = value.reduce((obj, cur)=> {
      const curElement = _.get(cur, field);
      if(!obj[curElement]) {
        obj[curElement] = [cur];
      } else {
        obj[curElement].push(cur);
      }
      return obj;
    }, {});
    return Object.keys(groupedObj).map(key => ({ key, items: groupedObj[key] }));
  }
}
